export default "__VITE_ASSET__qXhxl_s6__"